import apply from "./apply";
import admin from "./admin";

const stateChart = {
  initial: "apply",
  context: {},
  states: {
    apply,
    admin
  }
};

export default stateChart;
